import { IconX } from "@tabler/icons-react";
import { useState } from "react";

export enum TipType {
  information = "information",
  success = "success",
  warning = "warning",
  danger = "danger",
}

export enum TipSize {
  base = "base",
  small = "small",
}

interface TipProps {
  label: string;
  type?: TipType | `${TipType}`;
  size?: TipSize | `${TipSize}`;
  closable?: boolean;
}

const sizes: Record<TipSize, string> = {
  base: "typography-medium-base p-3",
  small: "typography-small-base p-2",
};

const colors: Record<TipType, string> = {
  information: "bg-bg-information",
  success: "bg-bg-success",
  warning: "bg-bg-warning",
  danger: "bg-bg-danger",
};

const Tip = ({
  label, type = TipType.information, size = TipSize.base, closable = false,
}: TipProps) => {
  const [closed, setClosed] = useState(false);
  return (
    <div className={`justify-between items-center rounded-lg w-[383px] gap-2
      ${colors[type]} ${sizes[size]} ${closed ? "hidden" : "flex"} ${closable ? "shadow-lg" : ""}`}
    >
      <span className="text-text-on-color">{label}</span>
      {closable && (
        <button type="button" onClick={() => setClosed(true)}>
          <IconX className="text-icon-on-color" />
        </button>
      )}
    </div>
  );
};

export default Tip;
